import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-only-icon',
  templateUrl: './view-only-icon.component.html',
  styleUrls: ['./view-only-icon.component.scss'],
})
export class ViewOnlyIconComponent {
  @Input() expanded = false;
  @Input() icon = './assets/icons/preview.svg';
  @Input() altText = 'View';
  @Input() action: (event: MouseEvent) => void = () => {};
}
